
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({ token: null, isAuthenticated: false, user: null, role: null, loading: true });

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            axios.defaults.headers.common['x-auth-token'] = token;
            axios.get('/api/users').then(res => {
                setAuth({ token, isAuthenticated: true, user: res.data, role: res.data.role, loading: false });
            }).catch(err => {
                console.error(err.response.data);
                localStorage.removeItem('token');
                setAuth({ token: null, isAuthenticated: false, user: null, role: null, loading: false });
            });
        } else {
            setAuth({ token: null, isAuthenticated: false, user: null, loading: false });
            delete axios.defaults.headers.common['x-auth-token'];
        }
    }, []);

    const setAuthToken = (token) => {
        localStorage.setItem('token', token);
        axios.defaults.headers.common['x-auth-token'] = token;
        axios.get('/api/users').then(res => {
            setAuth({ token, isAuthenticated: true, user: res.data, role: res.data.role, loading: false });
        }).catch(err => {
            console.error(err.response.data);
            localStorage.removeItem('token');
            setAuth({ token: null, isAuthenticated: false, user: null, role: null, loading: false });
        });
    };

    const login = async (formData) => {
        const res = await axios.post('/auth/login', formData);
        setAuthToken(res.data.jwtToken);
    };

    const logout = () => {
        localStorage.removeItem('token');
        setAuth({ token: null, isAuthenticated: false, user: null, loading: false });
        delete axios.defaults.headers.common['x-auth-token'];
    };

    return (
        <AuthContext.Provider value={{ auth, setAuth, login, logout, setAuthToken }}>
            {children}
        </AuthContext.Provider>
    );
};
